export enum ItemTreeType {
    customer = 'Customer',
    organization = 'Organization',
    user = 'User'
}